import { cn, kebabToCamelCase, localized } from "@blocks/utils";
import { SVG } from "@wordpress/components";
import { createElement } from "@wordpress/element";
import parse from "html-react-parser";
import React from "react";

type Props = {
	name?: string;
	className?: string;
	size?: number;
} & JSX.IntrinsicElements["svg"];

const IconRenderer: React.FC<Props> = (props) => {
	const { name, className = "", size = 24, ...otherProps } = props;

	if (!name) return null;

	const iconName = kebabToCamelCase(name);
	const icon =
		localized.icons.all?.[iconName] ?? localized.icons.all?.[name] ?? null;

	if (!icon) return null;

	const appliedProps = {
		width: size,
		height: size,
		...(parse(icon?.svg) as React.ReactElement)?.props,
		className: cn("magazine-blocks-icon", className),
		...otherProps,
	};

	return createElement(SVG, appliedProps);
};

export default IconRenderer;
